import React from "react"

// Primitivas de formulário do wizard — mobile-first, alvos de toque generosos.

interface FieldProps {
  label: string
  required?: boolean
  hint?: string
  error?: string | null
  children: React.ReactNode
}

export function Field({ label, required, hint, error, children }: FieldProps) {
  return (
    <label className="block">
      <span className="flex items-baseline justify-between">
        <span className="text-sm font-semibold text-ink">
          {label}
          {required && <span className="text-brand-600"> *</span>}
        </span>
        {hint && <span className="text-xs text-gray-400">{hint}</span>}
      </span>
      <div className="mt-1.5">{children}</div>
      {error && <span className="mt-1 block text-xs font-medium text-red-600">{error}</span>}
    </label>
  )
}

interface InputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  inputMode?: "text" | "numeric"
  autoFocus?: boolean
  onBlur?: () => void
}

export function Input({ value, onChange, placeholder, inputMode = "text", autoFocus, onBlur }: InputProps) {
  return (
    <input
      type="text"
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder={placeholder}
      inputMode={inputMode}
      autoFocus={autoFocus}
      className="w-full rounded-xl border-2 border-brand-100 bg-white px-4 py-3 text-base text-ink placeholder:text-gray-400 focus:border-brand-500 focus:outline-none focus:ring-4 focus:ring-brand-100 transition"
    />
  )
}

interface SelectProps {
  value: string
  onChange: (value: string) => void
  options: string[]
  labels?: Record<string, string>
  placeholder?: string
}

export function Select({ value, onChange, options, labels, placeholder }: SelectProps) {
  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className="w-full appearance-none rounded-xl border-2 border-brand-100 bg-white px-4 py-3 text-base text-ink focus:border-brand-500 focus:outline-none focus:ring-4 focus:ring-brand-100 transition"
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map(option => (
        <option key={option} value={option}>{labels?.[option] || option}</option>
      ))}
    </select>
  )
}

interface StepNavProps {
  onBack: () => void
  onContinue: () => void
  continueLabel?: string
  continueDisabled?: boolean
}

export function StepNav({ onBack, onContinue, continueLabel = "Continuar", continueDisabled }: StepNavProps) {
  return (
    <div className="mt-10 flex items-center justify-between">
      <button
        type="button"
        onClick={onBack}
        className="text-sm font-medium text-gray-500 hover:text-ink px-3 py-3 -ml-3 transition"
      >
        ← Voltar
      </button>
      <button
        type="button"
        onClick={onContinue}
        disabled={continueDisabled}
        className="rounded-xl bg-brand-600 px-8 py-3.5 text-base font-semibold text-white hover:bg-brand-700 disabled:opacity-40 disabled:cursor-not-allowed transition shadow-lg shadow-brand-900/10"
      >
        {continueLabel}
      </button>
    </div>
  )
}
